import client, { getDeviceId } from '../utils/client'
import { gql } from '@apollo/client'
import { MutationHandlerError } from '../utils/errors'

const CODE_LOGIN_MUTATION = gql`
	mutation CodeLogin($email: String!, $code: String!, $appId: String) {
		codeLogin(email: $email, code: $code, appId: $appId) {
			success
			jwt
			refreshToken
			userId
		}
	}
`

type CodeLoginResult =
	| { success: true; jwt: string; refreshToken: string; userId: string; errors: null }
	| {
			success: false
			jwt: undefined
			refreshToken: undefined
			userId: undefined
			errors: MutationHandlerError
	  }

const codeLogin = async ({
	email,
	code,
}: {
	email: string
	code: string
}): Promise<CodeLoginResult> => {
	try {
		const { data, errors } = await client.mutate({
			mutation: CODE_LOGIN_MUTATION,
			variables: { email, code, appId: getDeviceId() },
			errorPolicy: 'all',
		})
		if (errors)
			return { success: false, jwt: undefined, refreshToken: undefined, userId: undefined, errors }
		const jwt = data?.codeLogin?.jwt
		if (!jwt)
			return {
				success: false,
				jwt: undefined,
				refreshToken: undefined,
				userId: undefined,
				errors: 'Anmeldung fehlgeschlagen',
			}
		return {
			success: true,
			jwt,
			refreshToken: data.codeLogin.refreshToken,
			userId: data.codeLogin.userId,
			errors: null,
		}
	} catch (e) {
		if (e && e.networkError)
			return {
				success: false,
				jwt: undefined,
				refreshToken: undefined,
				userId: undefined,
				errors: 'NETWORK_ERROR',
			}
		throw e
	}
}

export default codeLogin
